import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { HomePage } from '../../../pages/home';

export const routes = (homePath) => ({
  path: homePath,
  pages: {
    home: {
      path: `${homePath}`,
    },
  },
});

export const HomeRoutes = ({ match: { url } }) => {
  const applicationRoutes = routes(url);
  return (
    <Switch>
      <Route path={applicationRoutes.pages.home.path} component={HomePage} />
      <Redirect to={applicationRoutes.path} />
    </Switch>
  );
};

HomeRoutes.propTypes = {};
